module.exports = __webpack_public_path__ + "img/18.01a7864f.png";